import React, { useContext, useState } from "react"
import useSWR from "swr"
import Fade from "@material-ui/core/Fade"
import Cookie from "js-cookie"
/** Service */
import vmsAPI from "services/Dashboard/VMS"
/** Components */
import Table from "components/Table"
import Loader from "components/Loader"
import { Context } from "context/Dashboard/VMS/categories/main/Context"
import tableHeaders from "./table/tableHeaders"
/** Context */
/** Interface */
interface TableVisitorsProps {
  activeFilter: number
}
const TableVisitors: React.FC<TableVisitorsProps> = ({ activeFilter }) => {
  const { setDownloadData } = useContext(Context)
  const [currentPage, setCurrentPage] = useState(0)

  const fetchAllVisitors = async () =>
    vmsAPI.getVMS({
      "vms_type": 1,
      "condo_uid": Cookie.get("condoUID")
    })

  const { data, isValidating } = useSWR(
    `fetchAllVisitors-${activeFilter}`,
    fetchAllVisitors,
    {
      revalidateOnFocus: true
    }
  )
  const tableData = data?.data?._data
  const filteredData = tableData?.filter((i: any) => i.vms.status === activeFilter)
  const activeData = activeFilter !== 0 ? filteredData : tableData

  if (isValidating) {
    return <Loader dark />
  }

  return (
    <Fade in={!isValidating} timeout={1500}>
      <div>
        <Table
          data={activeData || []}
          columns={tableHeaders(`fetchAllVisitors-${activeFilter}`)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isFilterable
          action={(values: any) => {
            return (
              setDownloadData &&
              setDownloadData(
                values?.map((i: any) => {
                  return {
                    "Status": i?.status,
                    "Category": i?.category,
                    "Block/Unit No.": i?.blockUnitNo,
                    "Name": i?.name,
                    "Mobile": i?.mobile,
                    "Email": i?.email,
                    "Purpose": i?.purpose,
                    "Multiple Visitors": i?.multipleVisitors,
                    "Visitors Count": i?.visitorsCount,
                    "Visitation Date": i?.visitationDate,
                    "Visitation Time": i?.visitationTime,
                    "Resident Name": i?.residentName,
                    "Remarks": i?.remarks,
                    "OTP": i?.otp
                  }
                })
              )
            )
          }}
        />
      </div>
    </Fade>
  )
}

export default TableVisitors
